import React from 'react';
import Image from 'next/image';

import { ISocialProofFields } from '../../../types/contentful';

import { Box } from '../Box';
import { BlockContainer, Layout, Column } from '../Layout';
import RichText from '../RichText';
import { Text } from '../Text';

import { featuredPress } from '../../data/featuredPress';

import {
  SocialProofContainer,
  PressItem,
  StarImage,
  SocialProofText
} from './styles';

export function SocialProof({
  bodyCopy,
  headingText,
  fullStar,
  partialStar
}: ISocialProofFields) {
  const { file, description } = fullStar?.fields ?? {};
  const { file: psFile, description: psDescription } =
    partialStar?.fields ?? {};

  return (
    <SocialProofContainer
      data-blockid="socialProofContainer"
      data-testid="socialProofContainer"
    >
      <BlockContainer
        id="socialProof"
        marginTop={{ 0: 'blockMarginY' }}
        marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
        data-blockid="socialProof"
      >
        <Layout
          backgroundColor="brand"
          borderRadius={{ 0: 'block', desktop: 'block_desktop' }}
          paddingTop={{ 0: 'l', tablet: 'xl' }}
          paddingBottom={{ 0: 'l', tablet: 'xl' }}
        >
          <Column size={{ 0: 10 }} flexDirection="column">
            <Box margin="auto">
              {file?.url && (
                <>
                  <StarImage src={`https:${file?.url}`} alt={description} />
                  <StarImage src={`https:${file?.url}`} alt={description} />
                  <StarImage src={`https:${file?.url}`} alt={description} />
                  <StarImage src={`https:${file?.url}`} alt={description} />
                </>
              )}
              {psFile?.url && (
                <StarImage src={`https:${psFile?.url}`} alt={psDescription} />
              )}
            </Box>
            <Text
              as="h2"
              fontWeight="h2"
              fontSize={{ 0: 'h2_0', tablet: 'h2_desktop' }}
              colour="defaultText"
              textAlign="center"
              style={{ letterSpacing: '.5px' }}
              margin={{ 0: ['m', 0] }}
              data-testid="componentHeader"
            >
              {headingText}
            </Text>
            <Box marginTop={{ 0: 'sm', tablet: 'm' }}>
              {bodyCopy && (
                <SocialProofText>
                  <RichText
                    data-testid="bodyCopy"
                    colour="defaultText"
                    data={bodyCopy}
                  />
                </SocialProofText>
              )}
            </Box>
          </Column>
        </Layout>
      </BlockContainer>
      <BlockContainer
        marginTop={{ 0: 0, tablet: 'm' }}
        marginBottom={{ 0: 0, tablet: 'm' }}
        data-blockid="asFeaturedOn"
      >
        <Layout data-blockid="asFeaturedOnLayout" gutter="sm">
          <Column
            size={12}
            flexWrap="wrap"
            justifyContent="space-evenly"
            alignItems="center"
          >
            {featuredPress.map(({ logoSrc, altText, rowIdx, multiplier }) => (
              <PressItem
                key={altText}
                rowIdx={rowIdx}
                multiplier={multiplier}
                margin={['s', 0]}
                padding={[0, 'xs']}
              >
                <Image src={logoSrc} alt={altText} />
              </PressItem>
            ))}
          </Column>
        </Layout>
      </BlockContainer>
    </SocialProofContainer>
  );
}
